import { colors } from '.';

const { mediumOrange, danger, lightBlue, lightGreen, fadedGrey } = colors;

export default [mediumOrange, danger, lightBlue, lightGreen, fadedGrey];
